import Tag from './Tag';
import Input from './Input';
var Exports = Tag;
Exports.Input = Input;
Exports.displayName = 'ShinoutTag';
export default Exports;